import type { UseProgressbarProps } from '@pearlconvert/ui/components/progressbar/progressbar.types'

export const useProgressbar = (props: UseProgressbarProps) => {
  const { progress = 0 } = props

  return {
    progress,
  }
}
